<script lang="ts">
    import Pricetag from "../../../widgets/Pricetag.svelte"

    export let product: BKDFProduct
    export let smallVersion: boolean = false
    const salePriceAmount = Number(product.salePrice.amount),
        minVariantPriceAmount = Number(product.priceRange.minVariantPrice.amount),
        hasDiscount = !isNaN(salePriceAmount) && salePriceAmount < minVariantPriceAmount
</script>

<div class="pricetag">
    {#if hasDiscount}
        <Pricetag
            oldPrice="{false}"
            discount="{true}"
            price="{product.salePrice}"
            smallVersion="{smallVersion}"
        />
    {/if}
    <Pricetag
        oldPrice="{hasDiscount}"
        discount="{false}"
        price="{product.priceRange.minVariantPrice}"
        smallVersion="{smallVersion}"
    />
</div>

<style lang="less">
    .pricetag {
        display: flex;
        gap: 0.5rem;
        margin-left: 7px;
    }
</style>
